import React from 'react';
// import Clarifai from 'clarifai';
import Particles from 'react-particles-js';
import Navigation from "./components/Navigation/Navigation";
import FaceRecognition from "./components/FaceRecognition/FaceRecognition";
import Logo from "./components/Logo/Logo";
import ImageLinkForm from "./components/ImageLinkForm/ImageLinkForm";
import Rank from "./components/Rank/Rank";
import Signin from "./components/Signin/Signin";


import './App.css';
import Register from './components/Register/Register';

// const app = new Clarifai.App({
//   apiKey: '73e8326fcef445ff88a7365601479aa5'
//  });

 const param = {
  "absorbers": [],
  "background": {},
  "backgroundMask": {
    "cover": {
      "color": {
        "value": "#fff"
      },
      "opacity": 1
    },
    "enable": false
  },
  "detectRetina": true,
  "emitters": [],
  "fpsLimit": 30,
  "interactivity": {
    "detectsOn": "canvas",
    "events": {
      "onClick": {
        "enable": false,
        "mode": "push"
      },
      "onDiv": {
        "elementId": "",
        "enable": false,
        "mode": []
      },
      "onHover": {
        "enable": false,
        "mode": "repulse",
        "parallax": {
          "enable": false,
          "force": 60,
          "smooth": 20
        }
      },
      "resize": true
    },
    "modes": {
      "absorbers": [],
      "bubble": {
        "distance": 400,
        "duration": 2,
        "opacity": 0.8,
        "size": 40
      },
      "connect": {
        "distance": 80,
        "lineLinked": {
          "opacity": 0.5
        },
        "radius": 60
      },
      "emitters": [],
      "grab": {
        "distance": 400,
        "lineLinked": {
          "opacity": 1
        }
      },
      "push": {
        "quantity": 4
      },
      "remove": {
        "quantity": 2
      },
      "repulse": {
        "distance": 200,
        "duration": 0.4,
        "speed": 1
      },
      "slow": {
        "factor": 3,
        "radius": 200
      }
    }
  },
  "particles": {
    "collisions": {
      "enable": true,
      "mode": "bounce"
    },
    "color": {
      "value": "#ffffff"
    },
    "lineLinked": {
      "blink": false,
      "color": {
        "value": "#ffffff"
      },
      "consent": false,
      "distance": 150,
      "enable": true,
      "opacity": 0.4,
      "shadow": {
        "blur": 5,
        "color": {
          "value": "lime"
        },
        "enable": false
      },
      "width": 1
    },
    "move": {
      "attract": {
        "enable": false,
        "rotate": {
          "x": 600,
          "y": 1200
        }
      },
      "direction": "none",
      "enable": true,
      "outMode": "out",
      "random": false,
      "speed": 2,
      "straight": false,
      "trail": {
        "enable": false,
        "length": 10,
        "fillColor": {
          "value": "#000000"
        }
      }
    },
    "number": {
      "density": {
        "enable": true,
        "area": 250
      },
      "limit": 0,
      "value": 100
    },
    "opacity": {
      "animation": {
        "enable": false,
        "minimumValue": 0.1,
        "speed": 1,
        "sync": false
      },
      "random": {
        "enable": false,
        "minimumValue": 1
      },
      "value": 0.5
    },
    "rotate": {
      "animation": {
        "enable": false,
        "speed": 0,
        "sync": false
      },
      "direction": "clockwise",
      "random": false,
      "value": 0
    },
    "shadow": {
      "blur": 0,
      "color": {
        "value": "#000000"
      },
      "enable": false,
      "offset": {
        "x": 0,
        "y": 0
      }
    },
    "shape": {
      "options": {
        "character": {
          "fill": true,
          "close": true,
          "font": "Verdana",
          "style": "",
          "value": "*",
          "weight": "400"
        },
        "char": {
          "fill": true,
          "close": true,
          "font": "Verdana",
          "style": "",
          "value": "*",
          "weight": "400"
        },
        "polygon": {
          "fill": true,
          "close": true,
          "sides": 5
        },
        "star": {
          "fill": true,
          "close": true,
          "sides": 5
        }
      },
      "image": {
        "fill": true,
        "close": true,
        "height": 100,
        "replaceColor": true,
        "src": "https://cdn.matteobruni.it/images/particles/github.svg",
        "width": 100
      },
      "type": "dot"
    },
    "size": {
      "animation": {
        "enable": false,
        "minimumValue": 0.1,
        "speed": 40,
        "sync": false
      },
      "random": {
        "enable": true,
        "minimumValue": 1
      },
      "value": 5
    },
    "stroke": {
      "color": {
        "value": "#fcfcfc"
      },
      "width": 0,
      "opacity": 1
    },
    "twinkle": {
      "lines": {
        "enable": false,
        "frequency": 0.05,
        "opacity": 1
      },
      "particles": {
        "enable": false,
        "frequency": 0.05,
        "opacity": 1
      }
    }
  },
  "pauseOnBlur": true,
  "polygon": {
    "draw": {
      "enable": false,
      "stroke": {
        "color": {
          "value": "#fff"
        },
        "width": 0.5,
        "opacity": 1
      }
    },
    "enable": false,
    "inline": {
      "arrangement": "one-per-point"
    },
    "move": {
      "radius": 10,
      "type": "path"
    },
    "scale": 1,
    "type": "none",
    "url": ""
  }
}

const initstate = {
  input: '',
  imageURL: '',
  box: {},
  messageDisplay: '',
  signin: 'signin',
  user: {
    id: '',
    name: '',
    email: '',
    entries: 0,
    joined: ''

  }
}
class App extends React.Component {
  constructor() {
    super();
    this.state = initstate;
  }
  
  loadUser = (data)=> {
    this.setState({
      user: {
        id: data.id,
        name: data.name,
        email: data.email,
        entries: data.entries,
        joined: data.joined

      }
    })
   
  }

  postion = (data)=>{
    const face = data.outputs[0].data.regions.map(element => element.region_info.bounding_box);
    
    //[0].region_info.bounding_box;
    const image = document.getElementById('image');
    const width = image.width;
    const height = image.height;
    return {
      leftcol: face.map(element => element.left_col*width), 
      toprow: face.map(element => element.top_row*height),
      rightcol: face.map(element => width - element.right_col*width),
      bottomrow: face.map(element => height - element.bottom_row*height)
    };
  }

  displayBox = (box)=> {
    
    this.setState({box: box});
    
    
  }
  
  onInputChange = (event)=> {
    this.setState({input: event.target.value});
  }
  onButtonClick = ()=> {
    this.setState({imageURL: this.state.input});
    
    // app.models.predict(Clarifai.FACE_DETECT_MODEL, this.state.imageURL)
    // app.models.predict(Clarifai.FACE_DETECT_MODEL, this.state.input)
    fetch('https://murmuring-savannah-14342.herokuapp.com/imageurl', {
          method: 'post',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            input: this.state.input
          })
        })
      .then(response=>response.json())
    .then((response)=>{
      if (response.outputs[0].data.regions) {
        
        fetch('https://murmuring-savannah-14342.herokuapp.com/image', {
          method: 'put',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            id: this.state.user.id
          })
        })
        .then(response=>response.json())
        .then(count=>{
          this.setState(Object.assign(this.state.user, {entries: count}))
        })
      
        this.displayBox( this.postion(response))
       
        this.setState({messageDisplay: ''});
    } else if (response === "unable to work with clarifai") {
          this.setState({messageDisplay : " Unable to connect to clarifai"});
    } else {
      this.setState({messageDisplay: " This picture does not have a face "});
    }
      
    })
    .catch(err=>this.setState({messageDisplay: "Error!!!"}));
    this.setState({box: {} });
  
  }
  onClickClick = (state) =>{
    if (state === 'signin') {
      this.setState(initstate);
    } else {
      this.setState({signin: state})
    }
    
  }


  render() {
    
    const {messageDisplay, imageURL, box, signin, user} = this.state;
   
    if(signin === 'home') {
     
      return (
      <div className="App">
        <Particles  className="parti" params= {param}/>
        <Navigation  onclick={this.onClickClick} issignedin={signin}/>
        <Logo />
       
        <Rank name={user.name} entries={user.entries}/>
        <ImageLinkForm onInputChange={this.onInputChange} onButtonClick={this.onButtonClick} /> 
     
        <FaceRecognition box={box} imageURL={imageURL} messageDisplay={messageDisplay}/>
        

      </div>
      );
    } else if(signin === 'signin'){
        return (
          <div className = "App">
            <Particles  className="parti" params= {param}/>
            <Navigation onclick={this.onClickClick} issignedin={signin} />
            <Logo />
            <Signin  onSubmit={this.onClickClick} loadUser={this.loadUser}/>
          </div>
        );

    } else {
       return (
         <div className = "App">
           <Particles  className="parti" params= {param}/>
           <Navigation onclick={this.onClickClick} issignedin={signin}/>
           <Logo />
           <Register onSubmit={this.onClickClick} loadUser={this.loadUser}/>
        </div>
      );

  }
    
  }
}

export default App;
